import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { CheckboxSimple } from '..//index.js';
import { FILTER_ICONS } from './icons.js';
const PADDING = 6;
export const DropDownMenuItem = (props) => {
    const wrapperRef = React.useRef(null);
    const labelRef = React.useRef(null);
    const [isHovered, setIsHovered] = React.useState(false);
    return (React.createElement(Wrapper, { onClick: props.onClick, ref: wrapperRef, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        props.checkbox && (React.createElement(CheckboxSimple, { checked: props.checkbox.checked, onChange: props.checkbox.onChange, onClick: (e) => e.stopPropagation(), style: {
                padding: PADDING,
                paddingRight: PADDING * 2,
            } })),
        props.icon && (React.createElement("div", { style: {
                paddingTop: PADDING,
                paddingBottom: PADDING,
                paddingLeft: props.checkbox ? 0 : PADDING,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } }, FILTER_ICONS[props.icon])),
        React.createElement(DropdownItemText, { ref: labelRef, style: {
                padding: PADDING,
                paddingLeft: props.checkbox && !props.icon ? 0 : PADDING,
            } }, props.label),
        isHovered &&
            labelRef.current &&
            labelRef.current.scrollWidth >
                labelRef.current.getBoundingClientRect().width + PADDING && (React.createElement(EllipsisTooltip, { style: {
                left: (wrapperRef.current?.getBoundingClientRect().width || 0) +
                    PADDING * 2,
                top: (wrapperRef.current?.offsetTop || 0) -
                    (wrapperRef.current?.parentElement?.scrollTop || 0),
            } }, props.label))));
};
const Wrapper = styled.div `
  transition: background-color 50ms ease-in-out;

  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: color-mix(in hsl, ${THEME.COLOR_GREY}, transparent 80%);
  }
`;
const DropdownItemText = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
`;
const EllipsisTooltip = styled.div `
  position: absolute;
  background-color: ${THEME.COLOR_SECONDARY};
  border-radius: 4px;
  padding: ${PADDING}px;
  max-width: 500px;
  min-width: 200px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
`;
//# sourceMappingURL=DropDownMenuItem.js.map